import { UI, HStack, Stack, VStack, Box } from '@genial/components';
import { BoxRadius } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import {
  ButtonSkeleton,
  DoubleTextSkeleton,
  ImageSkeleton,
  InputSkeleton,
  TextSkeleton,
} from '../../../../AssetsLoading';
import { LateralBar } from '../../../components/LateralBar';

export const ListLoadingItemTablet: React.FC = () => {
  return (
    <TableContent direction="column" space="stack.xxxs" p={0} px="inline.xxxs" py="stack.xxxs">
      <LateralBar
        backgroundColor="product.rendavariavel"
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <HStack justifyContent="space-between" w="full">
        <Stack w="full">
          <HStack w="full" alignItems="center" space="inline.xxxs">
            <ImageSkeleton />
            <DoubleTextSkeleton w="60%" />
          </HStack>
        </Stack>
      </HStack>
      <Box width="full" height="1px" bgColor="neutral.lightest" />
      <HStack justifyContent="space-between" w="full">
        <Stack w="2/9">
          <VStack space="stack.nano" justifyContent="space-between">
            <UI.Text color="neutral.black" variant="semibold">
              Ultimo preço
            </UI.Text>
            <DoubleTextSkeleton />
          </VStack>
        </Stack>
        <Stack w="2/9">
          <VStack space="stack.nano" justifyContent="space-between">
            <UI.Text color="neutral.black" variant="semibold">
              Melhor Compra
            </UI.Text>
            <TextSkeleton />
          </VStack>
        </Stack>
        <Stack w="2/9">
          <VStack space="stack.nano" justifyContent="space-between">
            <UI.Text color="neutral.black" variant="semibold">
              Melhor Venda
            </UI.Text>
            <TextSkeleton />
          </VStack>
        </Stack>
        <Stack w="1/6">
          <VStack space="stack.nano" justifyContent="space-between">
            <UI.Text color="neutral.black" variant="semibold">
              Fechamento
            </UI.Text>
            <TextSkeleton />
          </VStack>
        </Stack>
        <Stack w="1/7"></Stack>
      </HStack>
      <HStack justifyContent="space-between" w="full" alignItems="center">
        <Stack w="2/9">
          <VStack space="stack.quarck" justifyContent="space-between">
            <UI.Text color="neutral.black" variant="semibold">
              Tipo da ordem
            </UI.Text>
            <Stack pr="inline.xxxs">
              <InputSkeleton />
            </Stack>
          </VStack>
        </Stack>
        <Stack w="2/9">
          <VStack space="stack.quarck" justifyContent="space-between">
            <UI.Text color="neutral.black" variant="semibold">
              Quantidade
            </UI.Text>
            <Stack pr="inline.xxxs">
              <InputSkeleton />
            </Stack>
          </VStack>
        </Stack>
        <Stack w="2/9">
          <VStack space="stack.quarck" justifyContent="space-between">
            <UI.Text color="neutral.black" variant="semibold">
              Preço por ativo
            </UI.Text>
            <Stack pr="inline.xxxs">
              <InputSkeleton />
            </Stack>
          </VStack>
        </Stack>
        <Stack w="1/6">
          <VStack space="stack.quarck" justifyContent="space-between">
            <UI.Text color="neutral.black" variant="semibold">
              Total estimado
            </UI.Text>
            <TextSkeleton />
          </VStack>
        </Stack>
        <HStack w="1/7" space="inline.nano">
          <Stack w="1/2">
            <ButtonSkeleton />
          </Stack>
          <Stack w="1/2">
            <ButtonSkeleton />
          </Stack>
        </HStack>
      </HStack>
    </TableContent>
  );
};
